import { FC, lazy, Suspense, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Routes from 'src/components/Routes';
import ErrorBoundaryComponent from 'src/hoc/ErrorBoundary';

import store from './store';

import 'react-toastify/dist/ReactToastify.css';
import './styles/index.scss';

const PostHogProvider = lazy(() => import('posthog-js/react').then((module) => ({ default: module.PostHogProvider })));

const AppShell: FC = () => (
  <Provider store={store}>
    <ErrorBoundaryComponent>
      <div className="wrapper">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Routes />
      </div>
    </ErrorBoundaryComponent>
  </Provider>
);

const App: FC = () => {
  const [enableAnalytics, setEnableAnalytics] = useState(false);

  useEffect(() => {
    const analyticsTimer = window.setTimeout(() => {
      setEnableAnalytics(true);
    }, 5000);

    return () => window.clearTimeout(analyticsTimer);
  }, []);

  if (!enableAnalytics) {
    return <AppShell />;
  }

  return (
    <Suspense fallback={<AppShell />}>
      <PostHogProvider
        apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY as string}
        options={{ api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST }}
      >
        <AppShell />
      </PostHogProvider>
    </Suspense>
  );
};

export default App;
